import React, { ReactChild, ReactNode, ReactText } from 'react';
import './Label.less';
import classNames from 'classnames';
import { EnvagoAria } from '../../../aria.types';

const Label = ({
    children,
    className,
    aria,
    id
}: {
    children: ReactChild | ReactNode;
    className?: string;
    aria?: EnvagoAria;
    id?: string;
}) => {
    return (
        <div
            id={id}
            {...aria}
            className={classNames(
                'label text-gray-500 text-sm whitespace-nowrap mt-2 lg:mt-0',
                className,
            )}
        >
            {children}
        </div>
    );
};

export default Label;
